<!--
 * @Description: 头部导航
 * @Author: your name
 * @ Modified by: Your name
 * @ Modified time: 2019-07-30 10:23:17
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="header-nav-wrapper">
    <div class="header-nav-content">
      <div class="header-left">
        <div
          class="close-slider"
          @click="sliderBarSwitch">
          <i class="el-icon-s-fold"></i>
        </div>
        <span class="currentRouteName">{{$route.name}}</span>
      </div>
      <div class="header-right">
        <el-dropdown trigger="click" @command="handleUsers">
          <span class="dropdown-trigger">
            <i class="icon-user"></i>
              欢迎，{{userName ? userName : '个人中心'}}
            <i class="el-icon-arrow-down"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item divided command="editPwd">修改密码</el-dropdown-item>
            <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- 修改密码的弹窗 -->
    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      center
      width="400px"
      class="edit-dialog"
      >
      <dialog-main ref="dialogForm"></dialog-main>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small" type="info">取 消</el-button>
        <el-button @click="handleConfirm()" size="small" type="primary"
          :loading="loadingSearch">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { LOGOUT } from '../../libs/api'
import dialogMain from './dialogMain.vue'

export default {
  name: 'headerNav',
  components: { dialogMain },
  data() {
    return {
      loadingSearch: false, // 查询按钮加载中
      userName: sessionStorage.getItem('userName'),
      dialogVisible: false // 修改密码弹窗显示
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) { // 显示修改密码弹窗，清空原始数据
        this.handleFormReset()
      }
    }
  },
  methods: {
    // 缩小侧边栏
    sliderBarSwitch() {
      this.$bus.$emit('sliderBarSwitch')
    },
    // handleUsers 点击菜单项触发的事件回调
    handleUsers(type) {
      switch (type) {
      case 'logout':
        this.logout()
        break
      default:
        this.editPwd()
        break
      }
    },
    handleConfirm() {
      this.$refs.dialogForm.submitForm('ruleForm', this) // 调用弹窗的表单校验
    },
    handleFormReset() {
      if (this.$refs.dialogForm) {
        this.$refs.dialogForm.resetForm('ruleForm')
      }
    },
    logout() {
      this.$http.post(LOGOUT.LOGOUT)
        .then(() => {
          this.$router.push('/login')
          // 清除token
          sessionStorage.clear()
        }).catch(err => {
          this.$message.error(err)
        })
    },
    editPwd() {
      this.dialogVisible = true // 显示修改密码弹窗
    }
  }
}
</script>

<style lang="scss" scoped>
.header-nav-wrapper {
  height:40px;
  border-bottom: 1px solid #dfd7d7;
  & > .header-nav-content {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: space-between;
    & > .header-left{
      width: 200px;
      display: flex;
      .close-slider{ // 设置收缩侧边栏按钮样式
        display: inline-block;
        width: 75px;
        text-align: center;
        line-height: 39px;
        color: #A8A8A8;
        font-size: 24px;
        border-right: 1px solid rgba(0, 0, 0, .1);
        cursor: pointer;
        &:hover {
          background-color: #eee;
        }
      }
      .currentRouteName{ // 设置当前模块名字样式
        margin-left: 20px;
        width: 200px;
        color: #A8A8A8;
        height: 39px;
        line-height: 39px;
        display: inline-block;
      }
    }
    & > .header-right { // 设置个人中心
      width: 200px;
      height: 37px;
      line-height: 37px;
      text-align: center;
      color: #A8A8A8;
      .dropdown-trigger{ // 欢迎字体大小
        font-size: 15px;
      }
      i { // 头像字体大小
        font-size: 22px;
        color: #A8A8A8;
        margin-right: 10px;
      }
      .el-icon-arrow-down{ // 向下箭头大小
        font-size: 18px;
      }
    }
  }
}
</style>
